document.addEventListener("DOMContentLoaded", () => {
  initFaqAccordion();
});

document.addEventListener("turbo:load", () => {
  initFaqAccordion();
});

function initFaqAccordion() {
  const faqQuestions = document.querySelectorAll(".faq-question");
  if (!faqQuestions.length) return;

  faqQuestions.forEach((button) => {
    button.addEventListener("click", () => {
      const answer = button.nextElementSibling;
      const isOpen = answer.style.display === "block";

      // 他の開いているFAQを閉じる
      document.querySelectorAll(".faq-answer").forEach((ans) => {
        ans.style.display = "none";
      });

      // トグル動作
      if (!isOpen) {
        answer.style.display = "block";
      }
    });
  });
}